import { updateForm } from '../../utilities/api/allForms'
import './FormApproveModal.css'

export default function FormApproveModal({form, updateIntakeForm, toggleNotifications}) {
    const date = new Date();

    const confirmApproval = async () => {
        try {
            const res = await updateForm(form._id, {status: 'complete', approvalDate: date.toISOString().split('T')[0]})
            const updatedForm = res.form
            updateIntakeForm(updatedForm)
            toggleNotifications('success', `Form "${form.projectNumber}" Approved!`, '#FFFFFF')
        } catch (error) {
            console.log(error)
            toggleNotifications('error', `Failed to Approve Form "${form.projectNumber}"!`, '#FFFFFF')
        }
    }

  return (
    <div className='FormApproveModal modal fade' id='FormApproveModal' data-bs-keyboard="false" aria-labelledby={`FormApproveModalHeader`}>
        <div className='modal-dialog modal-dialog-centered'>
            <div className='modal-content'>
                <div className='modal-header'>
                    <svg width="40" viewBox="0 0 52 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g filter="url(#filter0_d_207_4032)">
                        <rect x="2" y="1.86328" width="48" height="48" rx="10" fill="white"/>
                        <rect x="2.5" y="2.36328" width="47" height="47" rx="9.5" stroke="#1A3860" strokeOpacity="0.08"/>
                        </g>
                        <path d="M19.808 27.9404C21.0091 27.9404 21.979 28.9106 21.979 30.1355V34.056C21.979 35.271 21.0076 36.25 19.808 36.25H15.921C14.731 36.25 13.75 35.269 13.75 34.056V30.1355C13.75 28.9125 14.7294 27.9404 15.921 27.9404H19.808ZM33.079 27.9404C34.2706 27.9404 35.25 28.9125 35.25 30.1355V34.056C35.25 35.269 34.269 36.25 33.079 36.25H29.192C27.9924 36.25 27.021 35.271 27.021 34.056V30.1355C27.021 28.9106 27.9909 27.9404 29.192 27.9404H33.079ZM19.808 14.75C21.0074 14.75 21.979 15.7288 21.979 16.9452V20.8656C21.979 22.0902 21.0095 23.0596 19.808 23.0596H15.921C14.729 23.0596 13.75 22.0883 13.75 20.8656V16.9452C13.75 15.7308 14.7311 14.75 15.921 14.75H19.808ZM33.079 14.75C34.2689 14.75 35.25 15.7308 35.25 16.9452V20.8656C35.25 22.0883 34.271 23.0596 33.079 23.0596H29.192C27.9905 23.0596 27.021 22.0902 27.021 20.8656V16.9452C27.021 15.7288 27.9926 14.75 29.192 14.75H33.079Z" fill="#344054" stroke="#344054" strokeWidth="1.5"/>
                    </svg>
                    &nbsp;&nbsp;
                    <div className='modal-title' id='FormApproveModalHeader'>Approve <span className='formTitle'>{form.projectNumber}</span></div>
                    <button type='button' className='btn-close' data-bs-dismiss='modal' aria-label='Close'></button>
                </div>
                <div className='modal-body'>
                    <p>Are you sure you want to approve this form?</p>
                    <p className='errorText'>Once approved, changes cannot be made.</p>
                </div>
                <div className='modal-footer'>
                    <button type='button' className='cancel' data-bs-dismiss='modal'>Cancel</button>
                    <button type='button' data-bs-dismiss='modal' onClick={confirmApproval} className='confirmApprovel'>Approve Form</button>
                </div>
            </div>
        </div>
    </div>
  )
}
